var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-right"},[_c('v-btn',{staticClass:"ml-n3 pa-1",attrs:{"x-small":"","color":_vm.groupSetting.mainColor,"icon":"","dark":""},on:{"click":_vm.deleteOrder}},[_c('v-icon',[_vm._v("mdi-delete-circle")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }